<div>
  <h2 class="pageHeader evaluator-user-roles">Other Roles ({{roles.length}})</h2>
  <ul class="evaluator-roles-list">
    @if (currentEvaluatorProgramRequestKey) {
      <li>
        <a class="weaveGrid programGrid" (click)="setCurrentEvaluator(null)">
          <mat-icon fontSet="material-icons-outlined">account_balance</mat-icon>
          <div class="evaluator-info">
            <div class="accreditor-name">{{userOrgName}}</div>
          </div>
        </a>
      </li>
    }
    @for (role of roles; track role) {
      @if (currentEvaluatorProgramRequestKey !== role.program.requestKey) {
        <li>
          <a class="weaveGrid programGrid" (click)="setCurrentEvaluator(role.program)">
            <div class="accreditorAvatar">
              @if(role.accreditor.thumbnail) {
                <img [src]="role.accreditor.thumbnail" [alt]="role.accreditor.name">
              } @else {
                <mat-icon fontSet="material-icons-outlined">account_balance</mat-icon>
              }
            </div>
            <div class="evaluator-info">
              <div class="evaluator-role">{{role.role}}</div>
              <div class="accreditor-name">{{role.accreditor.abbreviation || role.accreditor.name}}</div>
              <div class="evaluator-institution">{{role.institutionName}} - {{role.program.name}}</div>
            </div>
          </a>
        </li>
      }
    }
  </ul>
</div>
